import { Collapse, InternalLink, List, MenuItem } from '@color/continuum';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Ref, useState } from 'react';

import { AppPortalInfo } from 'ui/Auth/portals';

interface Props {
  forwardedRef: Ref<HTMLLIElement>;
  /*
   * Which portals the user allowed is allowed to switch to. These will populate the submenu.
   *
   * It's expected that this list exclude the currently-active portal.
   */
  switchablePortals: (AppPortalInfo & { path: string })[];
}

/**
 * This component renders a collection of app portals that the user may switch to.
 *
 * It does not attempt to define which portals a user is authorized to use.
 * See the parent `<MultiAppSwitcher>` which handles identifying portals.
 */
export const AppMenu: React.FC<Props> = ({ forwardedRef, switchablePortals }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const toggleMenuOpen = () => {
    setIsMenuOpen((oldOpen) => !oldOpen);
  };

  if (!switchablePortals.length) {
    return null;
  }

  return (
    <>
      <MenuItem
        ref={forwardedRef}
        onClick={toggleMenuOpen}
        sx={{ justifyContent: 'space-between' }}
      >
        <span>Use another Color product</span>
        {isMenuOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </MenuItem>

      <Collapse in={isMenuOpen} timeout="auto" unmountOnExit>
        <List>
          {switchablePortals.map((info) => (
            <MenuItem
              component={InternalLink}
              key={info.label}
              to={info.path}
              sx={{
                paddingLeft: 4,
                '&:hover': {
                  color: '#333',
                },
              }}
            >
              {info.label}
            </MenuItem>
          ))}
        </List>
      </Collapse>
    </>
  );
};
